/*!
 * Copyright (c) Atom Agency
 */


// VENDORS PLUGINS
import 'jquery.transit';
import 'malihu-custom-scrollbar-plugin';
import 'slick-carousel';
import 'fancybox-plus/dist/jquery.fancybox-plus';
// import 'jquery.scrollto';
// import 'jquery-bar-rating';
import '../js/vendors/bootstrap.min';
import '../js/vendors/jquery.typographer.orphan.min';
// import '../js/vendors/jquery.appear';
// import '../js/vendors/jquery.onscreen';
import '../js/vendors/SVG-inline';
// import '../js/vendors/jquery.scrollbar';
// import '../js/vendors/jquery.overflowing';
import '../js/vendors/jquery.selectric.min';
import '../js/vendors/jquery.selectric.placeholder';
import '../js/vendors/zabuto_calendar';
// import '../js/vendors/jquery.simplePagination';
// import '../js/vendors/jquery.range';
// import '../js/vendors/jquery.modal.min';
// import 'fullpage.js/vendors/scrolloverflow.min';
import '../js/vendors/scroll';
import '../js/vendors/objectFitPolyfill.min';
import 'fullpage.js';


// JQUERY PLUGINS
// import '../js/jquery.plugins/jquery.goLocation';
import '../js/jquery.plugins/jquery.slickCustom';
// import '../js/jquery.plugins/jquery.changeNavbar';
// import '../js/jquery.plugins/jquery.moveItem';
// import '../js/jquery.plugins/jquery.equalHeight';
// import '../js/jquery.plugins/jquery.counter_animate';
// import '../js/jquery.plugins/jquery.countDownDate';
import '../js/jquery.plugins/jquery.linesLimit';
import '../js/jquery.plugins/jquery.linesLimit2';
// import '../js/jquery.plugins/jquery.add3Dots';
// import '../js/jquery.plugins/jquery.dotsTooltip';
// import '../js/jquery.plugins/jquery.disableInputs';
// import '../js/jquery.plugins/jquery.ajaxPagination';

//COMPONENTS
import '../js/components/common';
import '../js/components/navbar';

// MAIN
import '../js/main';



// WEBPACK FOOTER //
// ./src/js/app.js